<div class="space-y-4">
    <div class="text-sm text-gray-500 leading-relaxed">
        จัดการสิทธิ์การเข้าใช้งานของผู้ใช้แต่ละคน
        <span class="block">เลือก role ที่ผู้ใช้สามารถใช้งานได้ และเลือก role หลักจาก dropdown</span>
    </div>

    @if (loading) {
    <div class="flex flex-col items-center py-6 space-y-3">
        <app-loader></app-loader>
        <div class="font-medium">Loading</div>
    </div>
    } @else {
    <div class="flex flex-col gap-3">
        @for (user of userDatasets; track user.user_id) {
        <div class="border border-gray-200 bg-white rounded-lg p-4">

            <!-- Header: avatar + name + selected role + request date -->
            <div class="flex flex-row gap-3 items-center mb-3">
                <img class="w-10 h-10 rounded-full flex-none object-cover bg-gray-100"
                    [src]="user.image || 'assets/images/user.png'"
                    onerror="this.onerror=null; this.src='assets/images/user.png'" alt="user">
                <div class="flex-1 min-w-0">
                    <div class="flex items-center gap-2 flex-wrap">
                        <div class="font-semibold truncate">{{user.name}}</div>
                        @if (user.role) {
                        <span class="label label-primary !text-xs">{{permissionService.getRole(user.role)}}</span>
                        } @else {
                        <span class="label label-light !text-xs border">ยังไม่มี role</span>
                        }
                    </div>
                    <div class="text-gray-500 text-xs">ส่งคำขอเมื่อ {{user.request_date}}</div>
                </div>
                <div class="flex-none">
                    <mat-form-field class="max-w-xs" subscriptSizing="dynamic">
                        <mat-select [value]="user.role" placeholder="เลือก role หลัก"
                            (selectionChange)="selectionRoleChange($event, user)">
                            <mat-option value="">ไม่กำหนด</mat-option>
                            @for (item of roles; track $index) {
                            <mat-option [value]="item.id">{{item.name}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <!-- Role chips toggle -->
            <div class="flex items-start gap-3 text-sm">
                <span class="text-xs font-semibold text-gray-600 w-24 flex-none mt-1.5">
                    Role ที่เปิดใช้งาน
                </span>
                <div class="flex flex-row gap-1.5 flex-wrap">
                    @for (role of permissionService.roles; track role.id) {
                    @if (checkRoleActive(role, user.permissions)) {
                    <button class="label label-secondary !text-xs flex items-center gap-1.5"
                        (click)="removeUserRole(role.id, user)">
                        <fa-icon [icon]="faCheck"></fa-icon>{{role.name}}
                    </button>
                    } @else {
                    <button class="label label-light !text-xs border flex items-center gap-1.5 opacity-70 hover:opacity-100"
                        (click)="addUserRole(role.id, user)">
                        <fa-icon [icon]="faXmark"></fa-icon>{{role.name}}
                    </button>
                    }
                    }
                </div>
            </div>
        </div>
        }
    </div>
    }
</div>
